export default __webpack_public_path__ + "static/media/628.b4520275.jpg";